(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineformelement = skyward.onlineformelement || {};

        var cancelEvent = function (e)
        {
            if (e.stopPropagation)
            {
                e.stopPropagation();
            }
            else
            {
                e.cancelBubble = true;
            }
        };

        var init = function (selector)
        {
            var elementID;
            var stepStatusID;
            var emergencyContactHash;
            var userCurrentPortal;

            $(selector + ' .onlineformelementquickentry').not('.onlineformelementeventsbound').each(function ()
            {
                var elementRepeaterParent = $(this);

                if (elementRepeaterParent.hasClass('js-onlineFormOrderedChildRecordQuickEntry'))
                {
                    let rowRemovedUpdateDeleteId;
                    let rowAddedUpdateAddId;
                    let isEmergencyContact = false;

                    if (elementRepeaterParent.hasClass('newstudentenrollmentphonerepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeletePhone';
                        rowAddedUpdateAddId = 'AddPhone';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentPhoneData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentemailrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmail';
                        rowAddedUpdateAddId = 'AddEmail';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentEmailData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentguardianrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteGuardian';
                        rowAddedUpdateAddId = 'AddGuardian';
                    }
                    else
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmergencyContact';
                        rowAddedUpdateAddId = 'AddEmergencyContact';
                        isEmergencyContact = true;
                    }

                    elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                    {
                        rowAddedUpdateOrder(newRow, rowAddedUpdateAddId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-removed', function (e, removedRow)
                    {
                        rowRemovedUpdateElementOrder(removedRow, rowRemovedUpdateDeleteId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-cleared', function (e, clearedRow, isRowBeingRemoved)
                    {
                        if (isRowBeingRemoved)
                        {
                            updateNextRows(clearedRow, isEmergencyContact);
                        }

                        cancelEvent(e);
                    });
                }

                elementRepeaterParent.addClass('onlineformelementeventsbound');

                elementRepeaterParent.find('.deletedphone,.deletedemail,.deletedguardian').each(function ()
                {
                    var tableRow = $(this).closest('.childrecordquickentryrow');
                    tableRow.hide();
                });
            });

            $(selector).find('.js-ElementFieldGroupTypeCode').change(function ()
            {
                var elementRepeaterParent = $(this).parents('.childrecordquickentryrow').eq(0);
                // clear out serialized overrides on field group change
                skyward.controls.setValue(elementRepeaterParent.find('.js-ElementSerializedLabelOverrides'), '');
                // reset button text on field group change if needed
                elementRepeaterParent.find('[data-click-action="onlineFormElement.openLabelOverrides"] > .buttonText').text(function (i, currText)
                {
                    if (currText && currText.indexOf('(Modified)') > -1)
                    {
                        return currText.substring(0, currText.indexOf('(Modified)')).trim();
                    }
                    return currText;
                });
            });

            var newDependentEnrollmentChange = function ()
            {
                var employeePlanEnrollmentFieldGroup = $(this).parents('.employeePlanEnrollmentFieldGroup');
                var newDependentEnrollmentCheckboxes = employeePlanEnrollmentFieldGroup.find("[id^='NewDependentEnrollment-']");
                var maximumDependentCountHidden = employeePlanEnrollmentFieldGroup.find("[id^='MaximumDependentCount-']");
                var maximumDependentCount = skyward.controls.getValue(maximumDependentCountHidden);

                var totalDependentsEnrolled = 0;
                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    if (skyward.controls.getValue(newDependentEnrollmentCheckbox))
                    {
                        totalDependentsEnrolled++;
                    }
                });

                var shouldGoToReadOnly = maximumDependentCount ? totalDependentsEnrolled >= maximumDependentCount : false;

                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    var isNewDependentEnrollmentCheckboxSelected = skyward.controls.getValue(newDependentEnrollmentCheckbox);

                    if (isNewDependentEnrollmentCheckboxSelected)
                    {
                        // If this condition is true this newDependentEnrollmentCheckbox is already selected and editable. We do not want to prevent them from deselecting the checkbox so there is no need to change anything.
                        return;
                    }

                    var isDependentEligibleForNewEnrollmentHiddenID = newDependentEnrollmentCheckbox
                        .getAttribute("id")
                        .replace("NewDependentEnrollment-", "IsDependentEligibleForNewEnrollment-");
                    var isDependentEligibleForNewEnrollmentHidden = $('#' + isDependentEligibleForNewEnrollmentHiddenID);
                    var isDependentEligibleForNewEnrollment = skyward.controls.getValue(isDependentEligibleForNewEnrollmentHidden);

                    if (!isDependentEligibleForNewEnrollment)
                    {
                        // If the new dependent enrollment is ineligible it will always be hidden and readonly so there is no need to change anything.
                        return;
                    }

                    if (shouldGoToReadOnly)
                    {
                        skyward.controls.disable(newDependentEnrollmentCheckbox);
                    }
                    else
                    {
                        skyward.controls.enable(newDependentEnrollmentCheckbox);
                    }
                });
            }

            $(selector).find("[id^='NewDependentEnrollment-']").on("change", newDependentEnrollmentChange);

            function addRowAddedUpdateIDsListener(elementRepeaterParent, dataClass)
            {
                elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                {
                    // Update IDs to be the correct format for our repeaters within the Guardian repeater
                    var previousRowInputId = newRow.prev('.childrecordquickentryrow').find('[id]:input:visible:eq(0)').attr('id');
                    if (previousRowInputId)
                    {
                        var parentOnScreenId = previousRowInputId.split('-')[3];
                        // Find any previous row data control to get correct ParentOnScreenID
                        newRow.find(dataClass + ',[data-validate-message-for],[data-validate-text-for]').each(function ()
                        {
                            var dataInput = $(this);
                            var dataInputId = dataInput.attr('data-validate-message-for') || dataInput.attr('data-validate-text-for') || dataInput.attr('id');
                            if (dataInputId)
                            {
                                var dataInputIdParts = dataInputId.replace(/childrecordquickentrychild(add)*-familyguardian-familyid(second)*-[0-9]+-/g, '').split('-');
                                dataInputIdParts[3] = parentOnScreenId;
                                var newId = dataInputIdParts.join('-');
                                if (dataInput.attr('id'))
                                {
                                    skyward.controls.changeId(dataInput, newId, newId);
                                }
                                if (dataInput.attr('data-validate-control-for'))
                                {
                                    dataInput.attr('data-validate-control-for', newId);
                                }
                                if (dataInput.attr('data-validate-message-for'))
                                {
                                    dataInput.attr('data-validate-message-for', newId);
                                }
                                if (dataInput.attr('data-validate-text-for'))
                                {
                                    dataInput.attr('data-validate-text-for', newId);
                                }
                            }
                        });
                    }

                    cancelEvent(e);
                });
            };
        };

        var parseElementOrderFromLabelText = function (elementOrderText)
        {
            var order = parseInt(elementOrderText, 10);
            if (!order && order !== 0)
            {
                order = 1;
            }
            return order
        };

        var rowAddedUpdateOrder = function (newRow, addId, isEmergencyContact)
        {
            var newRowelementOrderText = newRow.find('.elementOrderText:eq(0)');
            var hiddenAdd = newRow.find('[id^="' + addId + '-"]');
            skyward.controls.setValue(hiddenAdd, "true");

            var previousElementOrderValue = parseElementOrderFromLabelText(newRow.prev('.childrecordquickentryrow').find('.elementOrderText:eq(0)').val());
            if (previousElementOrderValue || previousElementOrderValue == 0)
            {
                skyward.controls.setValue(newRowelementOrderText, previousElementOrderValue + 1);
            }

            updateRowHeaderLabel(newRow, newRowelementOrderText, isEmergencyContact);
        };

        var rowRemovedUpdateElementOrder = function (removedRow, deleteId, isEmergencyContact)
        {
            var elementBeingRemoved = removedRow.find(`[id^="${removedRow.getPrefix()}${deleteId}"]`);
            skyward.controls.setValue(elementBeingRemoved, "true");

            updateNextRows(removedRow, isEmergencyContact);
        };

        var updateNextRows = function (clearedRow, isEmergencyContact)
        {
            var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderText').val());
            if (!elementOrder)
            {
                return;
            }

            clearedRow.nextAll('.childrecordquickentryrow').not('.removedElement').each(function ()
            {
                var nextRow = $(this);
                // TODO: will need to update this slightly for nested repeaters - make sure the .removedElement is truly in the removed repeater and not a nested repeater
                if (!nextRow.find('.removedElement').length)
                {
                    var elementOrderText = nextRow.find('.elementOrderText');
                    if (elementOrderText.length)
                    {
                        skyward.controls.setValue(elementOrderText, elementOrder);
                        elementOrder++;
                    }
                    updateRowHeaderLabel(nextRow, elementOrderText, isEmergencyContact);
                }
            });
        };

        var updateRowHeaderLabel = function (crqeRow, elementOrderText, isEmergencyContact)
        {
            var getElementOrderText = function ()
            {
                var orderText = crqeRow.find('.elementOrderText:eq(0)');
                if (orderText.length)
                {
                    return orderText;
                }
                return crqeRow.find('.elementOrderTextReadonly:eq(0)');
            };

            elementOrderText = elementOrderText || getElementOrderText();

            var elementOrderTextValue = elementOrderText.val();
            if (elementOrderTextValue)
            {
                const crqeRowOrderText = (elementOrderText.data('orderheadertext') || 'Emergency Contact #') + elementOrderTextValue;

                crqeRow.find('.legendHeader:eq(0)').text(crqeRowOrderText);

                if (isEmergencyContact)
                {
                    crqeRow.find('.emergencyContactPhoneSectionHeader:eq(0)').text(crqeRowOrderText + " Phones");
                    crqeRow.find('.emergencyContactEmailSectionHeader:eq(0)').text(crqeRowOrderText + " Emails");
                    crqeRow.find('.emergencyContactVehicleSectionHeader:eq(0)').text(crqeRowOrderText + " Vehicle");
                }
            }
        };

        var openLabelOverrides = function ()
        {
            var button = $(this);
            var buttonIdParts = button.attr('id').split('-');
            var isExisting = button.attr('id').indexOf('existing') > -1;
            var isWorkflow = button.attr('id').indexOf('workflow') > -1;
            var elementOrRowId = buttonIdParts[buttonIdParts.length - 1];
            var onlineFormElementContainer = button.parents('.onlineformelement:eq(0)');
            var fieldGroupTypeCode =
                skyward.controls.getValue(onlineFormElementContainer.find('.js-ElementFieldGroupTypeCode'));
            var onlineFormID = skyward.controls.getValue(onlineFormElementContainer.find('.js-OnlineFormID'));
            var currentSerializedOverrides = onlineFormElementContainer.find('.js-ElementSerializedLabelOverrides');

            if (!elementOrRowId || !fieldGroupTypeCode)
            {
                return;
            }

            var buildModalBody = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "OnlineForm/Element/LabelOverridesScreen",
                    dataType: "viewparthtml",
                    type: "POST",
                    data: {
                        ElementOrRowId: elementOrRowId,
                        FieldGroupTypeCode: fieldGroupTypeCode,
                        // getValue handles escaping characters in the JSON, like single-quotes
                        SerializedLabelOverrides: skyward.controls.getValue(currentSerializedOverrides)
                    }
                });
            };

            var gatherOverridesOnScreen = function ()
            {
                var postData = {};
                dialog.content.find("[name]").each(function ()
                {
                    postData[$(this).attr("name")] = $(this).encodedVal();
                });
                return postData;
            };

            var gatherElementDataOnScreen = function ()
            {
                var elementData = {};
                onlineFormElementContainer.find("[id]:visible").each(function ()
                {
                    elementData[$(this).attr("id")] = skyward.controls.getValue($(this));
                });
                return elementData;
            };

            var previewButtonClick = function ()
            {
                var postData = gatherOverridesOnScreen();
                postData["FieldGroupTypeCode"] = fieldGroupTypeCode;
                postData["OnlineFormID"] = onlineFormID;
                postData["SerializedElementData"] = JSON.stringify(gatherElementDataOnScreen());

                var buildPreviewModalBody = function ()
                {
                    var previewScreenUrl = skyward.global.virtualDir + "OnlineForm/Element/PreviewLabelOverridesScreen";
                    if (isWorkflow)
                    {
                        previewScreenUrl += "Workflow";
                    }

                    if (isExisting && elementOrRowId)
                    {
                        previewScreenUrl += "/" + elementOrRowId;
                    }
                    return $.ajax({
                        url: previewScreenUrl,
                        dataType: "viewparthtml",
                        type: "POST",
                        data: postData
                    });
                };

                var previewButtons = [
                    { text: "Close", click: function () { innerDialog.close(); }, icon: "Close" }
                ];

                var innerDialog = skyward.modalLayer.showDialog("Preview Label Overrides", buildPreviewModalBody, previewButtons);
            };

            var buttons = [
                {
                    text: "Preview",
                    click: previewButtonClick,
                    icon: "Eye"
                },
                {
                    text: "Save", click: function ()
                    {
                        var postData = gatherOverridesOnScreen();

                        $.ajax({
                            url: skyward.global.virtualDir + "OnlineForm/Element/SerializeLabelOverridesScreen",
                            dataType: "JSON",
                            type: "POST",
                            data: postData,
                            success: function (data)
                            {
                                if (data.errors)
                                {
                                    skyward.validation.displayValidationMessages(data, dialog.content, $("<div/>"));
                                    return;
                                }

                                var newValue = JSON.stringify(data);
                                if (newValue !== currentSerializedOverrides.val())
                                {
                                    skyward.controls.setValue(currentSerializedOverrides, newValue);
                                    button.find('.buttonText').text(function (index, currentText)
                                    {
                                        var textToAppend = " (Modified)";
                                        if (currentText.indexOf(textToAppend) === -1)
                                        {
                                            return currentText + textToAppend;
                                        }
                                        return currentText;
                                    });
                                }
                                dialog.close();
                            }
                        });
                    },
                    icon: "Save"
                },
                { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" }
            ];

            var dialog = skyward.modalLayer.showDialog("Element Label Overrides", buildModalBody, buttons);
        };

        var events = {
            "openLabelOverrides": openLabelOverrides
        };

        skyward.events.registerEvents("onlineFormElement", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
